import React from "react";
import { Modal, Button, FormInput } from "../../../components/ui";
import { Package } from "lucide-react";

export const RestockModal = ({ restockItem, onClose, restockQty, setRestockQty, onRestock, submitting }) => (
  <Modal 
    isOpen={!!restockItem} 
    onClose={onClose} 
    title={
      <div className="flex flex-col gap-0.5 z-10 relative">
        <span className="text-[14px] font-bold text-white font-serif tracking-widest uppercase">
          VERVE KITCHENS
        </span>
        <span className="text-[9px] text-slate-300 font-semibold tracking-widest uppercase">
          Restock Item
        </span>
      </div>
    } 
    size="sm"
  >
    {restockItem && (
      <div className="space-y-6 pt-2">
        <div className="bg-[#f0f7ff] rounded-2xl p-6 border border-blue-50 relative overflow-hidden group">
          <div className="absolute top-0 right-0 p-4 opacity-5 group-hover:opacity-10 transition-opacity">
            <Package size={80} />
          </div>
          <div className="relative">
            <div className="text-xl font-black text-slate-800 tracking-tight mb-3">
              {restockItem.itemName || restockItem.name}
            </div>
            <div className="flex gap-6">
              <div className="flex flex-col">
                <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-0.5">Current Stock</span>
                <span className="text-sm font-black text-brand-blue uppercase">
                  {restockItem.availableQty || restockItem.quantity || 0} {restockItem.unit || restockItem.units || 'Units'}
                </span>
              </div>
              <div className="flex flex-col border-l border-blue-100 pl-6">
                <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-0.5">Min. Level</span>
                <span className="text-sm font-black text-orange-500 uppercase">
                  {restockItem.minQty || 0} {restockItem.unit || restockItem.units || 'Units'}
                </span>
              </div>
            </div>
          </div>
        </div>

        <FormInput 
          label={`Quantity to Add (${restockItem.unit || restockItem.units || 'Units'})`}
          type="number"
          value={restockQty}
          onChange={e => setRestockQty(e.target.value)}
          placeholder="0"
          autoFocus
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onRestock(restockItem, restockQty);
            }
          }}
        />

        <div className="flex flex-col-reverse sm:flex-row items-center gap-3 pt-4 border-t border-slate-100 mt-2 pb-6 px-2">
          <button
            type="button"
            onClick={onClose}
            className="w-full sm:flex-1 cursor-pointer py-2.5 border border-slate-200 hover:bg-slate-50 text-slate-800 rounded-md text-[12px] font-semibold transition-all duration-300 ease-in-out shadow-sm"
          >
            Cancel
          </button>
          <button 
            type="button" 
            onClick={() => onRestock(restockItem, restockQty)} 
            disabled={submitting}
            className="w-full sm:flex-1 cursor-pointer py-2.5 min-h-[38px] bg-slate-900 hover:bg-black text-white rounded-md text-[12px] font-bold transition-all duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed border border-slate-900 shadow-sm flex items-center justify-center gap-2"
          >
            Confirm
          </button>
        </div>
      </div>
    )}
  </Modal>
);

